import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {
  @Input() sectionsArray: string[];
  @Input() whichStep = 1;
  sectionsList = [];
  sectionWidth = 0;
  statusBarCurrentLength = 0;
  statusBarTotalLength = 0;

  ngOnInit() {
    const sections = this.sectionsArray.length;
    this.statusBarTotalLength = ((sections - 1) / sections) * 100;
    this.statusBarCurrentLength =
      this.whichStep === 1 ? 0 : ((this.whichStep - 1) / (sections - 1)) * 100;
    this.sectionWidth = (1 / sections) * 100;

    this.sectionsArray.forEach((section, idx) => {
      const classes = [];
      idx++;
      if (this.whichStep >= idx) {
        classes.push('visited');
      }

      if (this.whichStep === idx) {
        classes.push('current');
      }
      this.sectionsList.push({ title: section, classes: classes });
    });
  }
}
